"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Clock = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var Clock = function Clock() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(-663.813 -84.01)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M698.6,91.1v-2h3.3c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2h-11c-1.2,0-2.2,1-2.2,2.2\r c0,1.2,1,2.2,2.2,2.2h3.3v2c-15.8,1.2-27.5,15-26.3,30.8c1.2,15.8,15,27.5,30.8,26.3c15.8-1.2,27.5-15,26.3-30.8\r C723.8,103.4,712.6,92.2,698.6,91.1L698.6,91.1z M696.3,143.8c-13.3,0-24.2-10.8-24.2-24.2s10.8-24.2,24.2-24.2\r c13.3,0,24.2,10.8,24.2,24.2c0,0,0,0,0,0C720.4,133,709.6,143.8,696.3,143.8z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M704.4,117.4h-5.8v-9.3c-0.1-1.2-1.1-2.2-2.3-2.1c-1.2,0.1-2.1,1-2.1,2.1v11.6\r c0,1.2,1,2.2,2.2,2.2l0,0h8.1c1.2,0,2.2-1,2.2-2.2C706.6,118.4,705.6,117.5,704.4,117.4L704.4,117.4z"
      })]
    })
  });
};
exports.Clock = Clock;